import React, { useEffect } from "react";
import "./Step4Card.css";
import { useDispatch, useSelector } from "react-redux";
import { stepsActions } from "../../../../store/steps-slice";
import axios from "axios";
import UNIVERSAL from "../../../../config/config";

const Step4Card = (props) => {
  const { data, key, step4Data } = props;

  const dispatch = useDispatch();

  const user = useSelector((state) => state.user.user);
  const coords = useSelector((state) => state.steps.coords);
  const campaignOrderId = useSelector((state) => state.steps.campaignOrderId);
  const step3 = useSelector((state) => state.steps.step3Data);
  const step4 = useSelector((state) => state.steps.step4Data);
  const campaigns = useSelector((state) => state.campaigns.data);

  const price = data.campaign_budget?.toLocaleString();

  useEffect(() => {
    if (!campaigns?.length)
      dispatch(
        stepsActions.step4({
          ...step4Data[0],
          img2: "https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/starter.svg",
        })
      );
  }, [campaigns]);

  async function handleSelectedCard(selectedId) {
    const selected = step4Data.find((data) => {
      return data.id === selectedId;
    });

    let img2 = "";

    if (data.plan_name === "Starter") {
      img2 = "https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/starter.svg";
    } else if (data.plan_name === "Growth") {
      img2 = "https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/growth.svg";
    } else if (data.plan_name === "Scale") {
      img2 = "https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/scale.svg";
    }

    dispatch(stepsActions.step4({ ...selected, img2: img2 }));

    await axios.post(
      UNIVERSAL.BASEURL_1 + "/campaigns/campaign_progress",
      {
        business_id: user.app_business_id,
        campaign_order_id: campaignOrderId,
        stage: "payment",
        campaign_order: {
          plan_id: selected.id,
          product_id: selected.product_id,
          campaign_objective: "BUSINESS_REACH",
          latitude: coords?.lat,
          longitude: coords?.lng,
          ad_templates: [
            {
              adCaption: step3.adCaption,
              adImage: step3.adImage,
            },
          ],
        },
      },
      {
        headers: {
          "x-api-key": "6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe",
        },
      }
    );
  }

  return (
    <div className={`step4Card ${step4 && step4.id === data.id ? "selectedStep4Card" : "notStep4Card"}`} onClick={(e) => handleSelectedCard(data.id)} key={key}>
      <div className="step4Card-info">
        <img
          className="step4Card-img1"
          src={
            (data.plan_name === "Starter" && "https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/starter-logo.svg") ||
            (data.plan_name === "Growth" && "https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/growth-logo.svg") ||
            (data.plan_name === "Scale" && "https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/scale-logo.svg")
          }
          alt="step4Card-img1"
        />
        <img
          className="step4Card-img2"
          src={
            (data.plan_name === "Starter" && "https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/starter.svg") ||
            (data.plan_name === "Growth" && "https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/growth.svg") ||
            (data.plan_name === "Scale" && "https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/scale.svg")
          }
          alt="step4Card-img2"
        />
        <p className="step4Card-priceSymbol">
          ₹<span className="step4Card-price">{price}</span>
        </p>
        <p className="step4Card-forPeople" style={{ display: "none" }}>
          Reach&nbsp;
          <span className="step4Card-people">{data.campaign_target}</span>&nbsp; people / ad
        </p>
      </div>
      {step4 && step4.id === data.id && (
        <div className="step4Tick">
          <img className="step4CardSelectedTick" src="/assets/icons/tickCircleFilled.svg" alt="card-selected-tick-icon" />
        </div>
      )}
    </div>
  );
};

export default Step4Card;
